<template lang="pug">
  .business-list-file
    .list-file-title Archivos
    b-row(cols="1" cols-sm="2" cols-md="4" no-gutters align-v="stretch")
      b-col(v-for="file in files")
        .file-list-item
          font-awesome-icon(:icon="['fas', 'file-pdf']" style="color:#D32B2B")
          a(:href="file.url" download target="_blank" style="font-size: 14px") {{file.name}}
          font-awesome-icon.btn-copy-url(@click="copyUrl(file.url)" :icon="['far', 'clone']")
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    files: {
      type: Array,
      default: () => []
    },
    service: Object
  },
  methods: {
    copyUrl (text) {
      const el = document.createElement('textarea')
      el.value = text
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
    }
  }
}
</script>

<style lang="scss" scoped>
.list-file-title {
  font-weight: bold;
  margin-bottom: 16px;
}
.file-list-item {
  height: calc(100% - 0.5rem);
  position: relative;
  padding: 8px 30px 8px 10px;
  text-decoration: none;
  color: #7F828F;
  margin: 0.25rem;
  border: 1px solid #E4E4E4;
  border-radius: 5px;
  svg {
      margin-right: 10px;
  }
}
.btn-copy-url {
  position: absolute;
  padding: 0;
  color: var(--primary);
  right: 3px;
  top: 12px;
  cursor: pointer;
}
</style>